import Button from './button';
import Ghost from './ghost';
import Link from './link';

Button.Ghost = Ghost;
Button.Link = Link;

export default Button;
